export const TIME_OFF_MODAL_DETAILS_GENERAL_TAB_1 = 'TIME_OFF_MODAL_DETAILS_GENERAL_TAB_1';
export const TIME_OFF_MODAL_DETAILS_GENERAL_TAB_2 = 'TIME_OFF_MODAL_DETAILS_GENERAL_TAB_2';
